import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "ring-offset-background focus-visible:ring-primary inline-flex scale-100 items-center justify-center rounded-sm text-sm font-medium transition-[transform,background-color] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-2 active:scale-95 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        // Brand == primary action
        brand: "rounded-lg bg-white text-focus hover:scale-110 active:bg-white",

        // “Rate” badge style == warning status
        "brand-rate":
          "text-inverse-default rounded-lg bg-status-warning hover:scale-110 hover:bg-status-warning-subtle",

        // Dashboard sidebar item
        sidedash:
          "rounded-lg bg-nav text-[var(--text-nav-active)] hover:scale-110 hover:bg-nav-hover hover:text-[var(--text-nav-hover)]",

        primary:
          "rounded-lg bg-action-primary text-action-primary-foreground hover:scale-110 hover:bg-action-primary-hover active:bg-action-primary-active",

        secondary:
          "rounded-lg bg-action-secondary text-action-secondary-foreground hover:scale-110 hover:bg-action-secondary-hover active:bg-action-secondary-active",

        error:
          "rounded-lg bg-status-danger text-white hover:scale-110 hover:bg-status-danger hover:text-white",
        warning:
          "rounded-lg bg-status-warning text-status-warning-foreground hover:scale-110 hover:bg-status-warning-subtle",
        info: "rounded-lg bg-status-info text-status-info-foreground hover:scale-110 hover:bg-status-info-subtle",
        success:
          "rounded-lg bg-status-success text-status-success-foreground hover:scale-110 hover:bg-status-success-subtle",

        outline:
          "border-border-input-default rounded-lg border bg-transparent text-action-secondary-foreground hover:scale-110 hover:bg-action-secondary-hover hover:text-action-secondary-foreground",

        ghost:
          "rounded-lg bg-transparent text-action-secondary-foreground hover:scale-110 hover:bg-action-secondary-hover hover:text-action-secondary-foreground",

        link: "text-text-brand underline-offset-4 hover:scale-110 hover:underline",
        "sidebar-button":
          "hover:text-admin-disabled justify-start border-b-admin-border bg-transparent text-admin-text-muted",
      },
      size: {
        xs: "h-6 px-2 text-xs",
        sm: "h-8 px-4 text-xs",
        md: "h-9 px-5",
        lg: "h-10 px-6",
        icon: "size-9",
      },
    },
    compoundVariants: [
      { variant: "link", size: "sm", className: "h-auto px-0" },
      { variant: "link", size: "md", className: "h-auto px-0" },
      { variant: "link", size: "lg", className: "h-auto px-0" },
    ],
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);
